/* Schinkendiele Altersprüfung – Popup auf Produktseiten + Pflicht-Haken im Warenkorb */
(function () {
  'use strict';
  if (window.sdAgeGate) return;
  window.sdAgeGate = true;

  var STORAGE_KEY = 'sd-age-ok';
  var CART_ATTRIBUTE = 'Altersbestätigung';
  var CHECKOUT = '[name="checkout"], a[href$="/checkout"]';

  /* ---------- Popup ---------- */
  var gate = document.getElementById('sd-age');
  if (gate) {
    var yes = gate.querySelector('[data-sd-age-yes]');
    var no = gate.querySelector('[data-sd-age-no]');

    if (!gate.hidden) yes.focus();

    yes.addEventListener('click', function () {
      try { localStorage.setItem(STORAGE_KEY, String(Date.now())); } catch (e) {}
      gate.hidden = true;
      document.documentElement.classList.remove('sd-age-open');
    });

    // Zurück zur vorherigen Shop-Seite, sonst zur Startseite
    no.addEventListener('click', function () {
      var cameFromShop = false;
      try {
        var ref = new URL(document.referrer);
        cameFromShop = ref.origin === location.origin && ref.pathname !== location.pathname;
      } catch (e) {}
      if (cameFromShop && history.length > 1) history.back();
      else location.href = gate.dataset.home || '/';
    });

    // Fokus im Dialog halten, Escape schließt nicht
    gate.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); return; }
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === yes) { e.preventDefault(); no.focus(); }
      else if (!e.shiftKey && document.activeElement === no) { e.preventDefault(); yes.focus(); }
    });
  }

  /* ---------- Warenkorb-Haken ---------- */
  var pendingSave = null;
  var confirmedHere = null; // was der Kunde auf dieser Seite angehakt hat

  function syncLocks() {
    document.querySelectorAll('[data-sd-age-confirm]').forEach(function (box) {
      if (!box.closest('[data-sd-age-scope]')) box.parentElement.setAttribute('data-sd-age-scope', '');
    });
    document.querySelectorAll('[data-sd-age-scope]').forEach(function (scope) {
      var input = scope.querySelector('[data-sd-age-input]');
      scope.classList.toggle('sd-age-locked', !!input && !input.checked);
    });
  }

  function lockedInput(el) {
    var scope = el.closest('[data-sd-age-scope]');
    var input = scope && scope.querySelector('[data-sd-age-input]');
    return input && !input.checked ? input : null;
  }

  function showError(input) {
    var box = input.closest('[data-sd-age-confirm]');
    box.classList.remove('is-error');
    void box.offsetWidth;
    box.classList.add('is-error');
    box.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    input.focus({ preventScroll: true });
  }

  function saveAttribute(confirmed) {
    var attributes = {};
    attributes[CART_ATTRIBUTE] = confirmed ? '18+ bestätigt am ' + new Date().toLocaleString('de-DE') : '';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var request = fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).catch(function () {});
    pendingSave = request;
    request.then(function () { if (pendingSave === request) pendingSave = null; });
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('[data-sd-age-input]');
    if (!input) return;
    input.closest('[data-sd-age-confirm]').classList.remove('is-error');
    confirmedHere = input.checked;
    // Drawer und Warenkorbseite gleich halten
    document.querySelectorAll('[data-sd-age-input]').forEach(function (other) { other.checked = input.checked; });
    syncLocks();
    saveAttribute(input.checked);
  });

  // Kasse sperren, solange der Haken fehlt; nach dem Haken erst speichern, dann weiter
  document.addEventListener('click', function (e) {
    var button = e.target.closest && e.target.closest(CHECKOUT);
    if (!button) return;
    var input = lockedInput(button);
    if (input) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showError(input);
    } else if (pendingSave && button.closest('[data-sd-age-scope]')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      pendingSave.then(function () { pendingSave = null; button.click(); });
    }
  }, true);

  document.addEventListener('submit', function (e) {
    var submitter = e.submitter;
    if (!submitter || !submitter.matches(CHECKOUT)) return;
    var input = lockedInput(submitter);
    if (input) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showError(input);
    }
  }, true);

  // Minimog aktualisiert bei Warenkorb-Änderungen nur die Artikel, daher den Haken selbst neu laden
  function refreshConfirm() {
    var slots = document.querySelectorAll('[data-sd-age-slot]');
    if (!slots.length) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart?section_id=sd-age-cart-confirm')
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-sd-age-slot]');
        var markup = fresh ? fresh.innerHTML : '';
        slots.forEach(function (slot) { slot.innerHTML = markup; });
        if (confirmedHere !== null) {
          document.querySelectorAll('[data-sd-age-input]').forEach(function (input) { input.checked = confirmedHere; });
        }
        syncLocks();
      })
      .catch(function () {});
  }

  // Theme-Scripts laden nach diesem Script, daher erst nach DOMContentLoaded anmelden
  document.addEventListener('DOMContentLoaded', function () {
    if (window.MinimogEvents && window.MinimogTheme && MinimogTheme.pubSubEvents) {
      MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, refreshConfirm);
    }
  });

  // Der Warenkorb-Drawer wird nach jeder Änderung neu gerendert
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; syncLocks(); });
  }).observe(document.body, { childList: true, subtree: true });

  syncLocks();
})();
